import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { UserDataCache } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class UserCacheService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  get(loader: string, entityId: string, view: string, type: string): Observable<UserDataCache> {
    this.loadersService.show(loader);

    return this.http
      .get<UserDataCache>(`${this.baseUrl}/users/cache`, {
        params: httpParams().from({ entityId, view, type }).build(),
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  add(loader: string, dto: UserDataCache): Observable<UserDataCache> {
    this.loadersService.show(loader);
    return this.http
      .post<UserDataCache>(this.baseUrl + '/users/cache', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  clear(loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.delete(`${this.baseUrl}/users/cache`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
